module.exports = __webpack_public_path__ + "img/item4-2.bbc9f16d.jpg";